export enum Metadata$FieldType {
  STRING = 'System.String',
  INTEGER = 'System.Int32',
  DECIMAL = 'System.Double',
  DATE = 'System.DateTime',
}

export const MetadataFormatters = {
  [Metadata$FieldType.DATE]: /./,
  [Metadata$FieldType.STRING]: /./,
  [Metadata$FieldType.INTEGER]: /^-?([1-9]\d*|0)$/,
  [Metadata$FieldType.DECIMAL]: /^0$|^[1-9]\d*$|^\.\d+$|^0\.\d*$|^[1-9]\d*\.\d*$/,
};

export type PrepopulatedValue = {
  isDefault: boolean;
  value: string | number | Date | null;
};

export type Metadata$Field = {
  type: Metadata$FieldType;
  name: string;
  description: Nullable<string>;
  createdDate: Date;
  allowFreeEntryValue: boolean;
  predefinedValues: PrepopulatedValue[];
} & Entity;

export type Metadata = {
  fieldId: string;
  value: string | number | Date;
} & Entity;

export type Metadata$Template = {
  name: string;
  description: string;
  fieldIds: string[];
  createdDate: Date;
} & Entity;
